export const roundUpAndReturnNum = (num) => {
    if (isNaN(num)) {
        return 0;
    }
    const roundedNum = Math.round(num * 100) / 100;
    return roundedNum;
};
